/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
// istanbul ignore file
// TODO: BRG-812 Write tests for encryption library

const arrayBufferToBase64 = buffer => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};
export const convertBase64ToBase64UrlEncoding = base64String => {
  // Replacing '+' with '-', '/' with '_' and removing '=' characters from string to convert
  // base64 encoded string to base64Url encoded string.
  return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};
const encodeArrayBufferToBase64Url = arrayBuffer => {
  const base64String = arrayBufferToBase64(arrayBuffer);
  return convertBase64ToBase64UrlEncoding(base64String);
};
const encryptArrayBufferUsingAES = async arrayBuffer => {
  const algorithm = 'AES-GCM';
  const cryptoAesKey = await window.crypto.subtle.generateKey({
    length: 256,
    name: algorithm
  }, true, ['encrypt', 'decrypt']);
  const aesIv = window.crypto.getRandomValues(new Uint8Array(12));
  const aesGcmParams = {
    iv: aesIv,
    name: 'AES-GCM'
  };
  const aesKeyBuffer = await window.crypto.subtle.exportKey('raw', cryptoAesKey);
  const encryptedBuffer = await crypto.subtle.encrypt(aesGcmParams, cryptoAesKey, arrayBuffer);
  return {
    aesIvBuffer: aesIv.buffer,
    aesKeyBuffer,
    encryptedBuffer
  };
};
const encryptArrayBufferUsingRSA = async (arrayBuffer, rsaKey) => {
  const algorithm = {
    hash: 'SHA-256',
    name: 'RSA-OAEP'
  };
  const format = 'jwk';
  const keyUsages = ['encrypt'];
  const cryptoRsaKey = await window.crypto.subtle.importKey(format, rsaKey, algorithm, false, keyUsages);
  const encryptedArrayBuffer = await crypto.subtle.encrypt(algorithm, cryptoRsaKey, arrayBuffer);
  return encryptedArrayBuffer;
};
export const encryptFile = async (file, rsaKey) => {
  // generate random AES key and encrypt
  const fileArrayBuffer = await file.arrayBuffer();
  const {
    encryptedBuffer: encryptedFileBuffer,
    aesKeyBuffer,
    aesIvBuffer
  } = await encryptArrayBufferUsingAES(fileArrayBuffer);
  const base64UrlEncodedFileBuffer = encodeArrayBufferToBase64Url(encryptedFileBuffer);
  const base64UrlEncodedAesIv = encodeArrayBufferToBase64Url(aesIvBuffer);

  // encrypt the AES key with RSA
  const encryptedAesKeyBuffer = await encryptArrayBufferUsingRSA(aesKeyBuffer, rsaKey);
  const base64UrlEncodedAesKeyBuffer = encodeArrayBufferToBase64Url(encryptedAesKeyBuffer);
  return {
    aesIv: base64UrlEncodedAesIv,
    aesKey: base64UrlEncodedAesKeyBuffer,
    userKey: base64UrlEncodedFileBuffer
  };
};